import * as React from "react";

interface SVGComponentProps {
  color?: string;
}

const GuideIcon: React.FC<SVGComponentProps> = ({ color = "#828282", ...props }) => (
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.5 2.75h4.25c.69 0 1.25.56 1.25 1.25v10.5c0-.41-.34-.75-.75-.75H3.5a.75.75 0 0 1-.75-.75V3.5c0-.41.34-.75.75-.75Zm6 0h4.25c.41 0 .75.34.75.75v10.25c0 .41-.34.75-.75.75H9.5a.75.75 0 0 0-.75.75V4c0-.69.56-1.25 1.25-1.25Z"
      stroke={color}
      strokeWidth={1.2}
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default GuideIcon;
